import { type Path } from 'react-hook-form';

import { type DraftProctorRequestEditionFormInput } from './schemas';

type PathOfDraftProctorRequestEditionFormType = Path<DraftProctorRequestEditionFormInput>;

export const DRAFT_PROCTOR_REQUEST_FORM_FIELD_NAME = {
  proctorType: 'proctorType',
  personal: {
    idNumber: 'personal.idNumber',
    titleTh: 'personal.titleTh',
    firstNameTh: 'personal.firstNameTh',
    lastNameTh: 'personal.lastNameTh',
    titleEn: 'personal.titleEn',
    firstNameEn: 'personal.firstNameEn',
    lastNameEn: 'personal.lastNameEn',
    email: 'personal.email',
    phoneNumber: 'personal.phoneNumber',
    address: 'personal.address',
  },
  employeeInfo: {
    code: 'employeeInfo.code',
    position: 'employeeInfo.position',
    department: 'employeeInfo.department',
    startedAt: 'employeeInfo.startedAt',
    termination: {
      isAssigned: 'employeeInfo.termination.isAssigned',
      endedAt: 'employeeInfo.termination.endedAt',
    },
  },
  document: {
    agreementForms: 'document.agreementForms',
    identifications: 'document.identifications',
  },
} as const satisfies {
  proctorType: PathOfDraftProctorRequestEditionFormType;
  personal: Record<string, PathOfDraftProctorRequestEditionFormType>;
  employeeInfo: Record<
    string,
    | PathOfDraftProctorRequestEditionFormType
    | Record<string, PathOfDraftProctorRequestEditionFormType>
  >;
  document: Record<string, PathOfDraftProctorRequestEditionFormType>;
};
